/**
 * SuperChickenMenu Component
 * 
 * This is a legacy wrapper that now uses the new refactored MenuContainer.
 * Kept for backward compatibility.
 * 
 * @deprecated Use MenuContainer from '@/components/menu' instead
 */

import { MenuContainer } from '@/components/menu';
import type { Branch } from '@/types/index';
import type { ViewContentParams } from '@/types/metaPixel';
import { PublicMenuData } from '@/hooks/usePublicMenuFullData';

interface SuperChickenMenuProps {
  branch: Branch;
  enableRatings?: boolean;
  enableOrdering?: boolean;
  onTrackViewContent?: (params: ViewContentParams) => void;
  isPreview?: boolean;
  showCart?: boolean;
  preloadedData?: PublicMenuData;
}

export function SuperChickenMenu({ branch, enableRatings, enableOrdering, onTrackViewContent, isPreview = false, showCart = true, preloadedData }: SuperChickenMenuProps) {
  return (
    <MenuContainer
      branch={branch}
      enableRatings={enableRatings}
      enableOrdering={enableOrdering}
      onTrackViewContent={onTrackViewContent}
      isPreview={isPreview}
      showCart={showCart}
      preloadedData={preloadedData}
    />
  );
}
